import slsConfig from 'sls-stack-output.json';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';

export const userPool = new AmazonCognitoIdentity.CognitoUserPool({
  UserPoolId: slsConfig.CognitoUserPoolId,
  ClientId: slsConfig.CognitoClientId,
});
